"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const event_fragment_1 = __importDefault(require("../fragments/event.fragment"));
const mutation = (0, client_1.gql) `
  mutation createEvent($event: EventInput!) {
    createEvent(event: $event) {
      _id
      orgId
      type
      name
      seasonId
      subtitle
      description
      userAgreement
      processAs
      posterImageUrl {
        original
        medium
        small
      }
      venueId
      duplicateEventId
      createdAt
      publishable
      seatingChartKey
      age
      taxDeduction
      physicalDeliveryInstructions
      ticketDeliveryType
      isMultipleDays
      multiDayEntry
      totalDays
      cancel
      sendQRCode
      hasOrders
      subscription {
        _id
      email
      frequency
      }
      organization {
        orgName
        stripeId
      }
      venue {
        _id
        name
        tax
        address {
          state
          city
          timezone
        }
        imageUrls
      }
      stub
      published
      salesBeginImmediately
      isEventTegIntegration
      ...EventSchedule
      ...Location
      ...Performances
      ...TicketTypes
      ...TicketHolds
      ...EventUpgrades
      ...EventPromotions
      ...EventCustomFields
      ...TicketExchange
      ...Fees
      ...Artists
      ...WebFlowEntity
      ...Analytics
    }
  }

  ${event_fragment_1.default.fragments.schedule}
  ${event_fragment_1.default.fragments.location}
  ${event_fragment_1.default.fragments.performances}
  ${event_fragment_1.default.fragments.ticketTypes}
  ${event_fragment_1.default.fragments.holds}
  ${event_fragment_1.default.fragments.upgrades}
  ${event_fragment_1.default.fragments.promotions}
  ${event_fragment_1.default.fragments.customFields}
  ${event_fragment_1.default.fragments.exchange}
  ${event_fragment_1.default.fragments.fees}
  ${event_fragment_1.default.fragments.artists}
  ${event_fragment_1.default.fragments.webFlowEntity}
  ${event_fragment_1.default.fragments.analytics}
`;
exports.default = mutation;
//# sourceMappingURL=createEvent.mutation.js.map